// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1wq0C","title":"Images45_title__3CLtg","images":"Images45_images__2C6iD"};